import V2Text from '__pc__/components/common/v2Design/text';
import { V2BackgroundColors } from '__pc__/constant/v2Design/Colors/V2BackgroundColors';
import { RadiusValue } from '__pc__/constant/v2Design/RadiusType';
import { SpaceValue } from '__pc__/constant/v2Design/SpaceType';
import { V2TextOption } from '__pc__/constant/v2Design/V2TextType';
import { inject, observer } from 'mobx-react';
import { injectStore } from 'models/store';
import styled from 'styled-components';
import MatchMessageStore from 'models/MatchMessageStore';
import { FC } from 'react';

const Frame = styled.div`
display: flex;
flex-direction: column;
padding:${SpaceValue.XL}px ${SpaceValue.L}px 152px ${SpaceValue.L}px;
gap:${SpaceValue.XL}px;
`;
const JDEachFrame = styled.div`
    display: flex;
    flex-direction: column;
    gap:8px;
    .desc{
        display: flex;
        flex-direction: column;
        padding:${SpaceValue.M}px;
        background-color: ${V2BackgroundColors.surface_alternative};
        border-radius: ${RadiusValue.M}px;
    }
`;

interface IMatchApplyJobDescriptionProps {
  matchMessageStore?: MatchMessageStore;
}
const MatchApplyJobDescription: FC<IMatchApplyJobDescriptionProps> = ({ matchMessageStore = new MatchMessageStore() }) => {
  return (
    <Frame>
      <JDEachFrame>
        <V2Text fontStyle={V2TextOption.fontStyle.body_2_sb} color={V2TextOption.color.subtle}>
          채용하는 직무
        </V2Text>
        <div className='desc'>
          <V2Text fontStyle={V2TextOption.fontStyle.body_2_sb} color={V2TextOption.color.default}>
            {`• ${matchMessageStore.matchingMessage?.jobDescription.title}`}
          </V2Text>
        </div>
      </JDEachFrame>
      <JDEachFrame>
        <V2Text fontStyle={V2TextOption.fontStyle.body_2_sb} color={V2TextOption.color.subtle}>
          채용하는 직무
        </V2Text>
        <div className='desc'>
          {
            matchMessageStore.matchingMessage?.jobDescription.descriptions.map((description) => (
              <V2Text fontStyle={V2TextOption.fontStyle.body_2_sb} color={V2TextOption.color.default}>
                • {description}
              </V2Text>
            ))
          }

        </div>
      </JDEachFrame>
      <JDEachFrame>
        <V2Text fontStyle={V2TextOption.fontStyle.body_2_sb} color={V2TextOption.color.subtle}>
          필요 스킬
        </V2Text>
        <div className='desc'>
          {
            matchMessageStore.matchingMessage?.jobDescription.requiredSkills.map((skill) => (
              <V2Text fontStyle={V2TextOption.fontStyle.body_2_sb} color={V2TextOption.color.default}>
                • {skill}
              </V2Text>
            ))
          }
        </div>
      </JDEachFrame>
      <JDEachFrame>
        <V2Text fontStyle={V2TextOption.fontStyle.body_2_sb} color={V2TextOption.color.subtle}>
          선호 스킬
        </V2Text>
        <div className='desc'>
          {
            matchMessageStore.matchingMessage?.jobDescription.preferredSkills.map((skill) => (
              <V2Text fontStyle={V2TextOption.fontStyle.body_2_sb} color={V2TextOption.color.default}>
                • {skill}
              </V2Text>
            ))
          }
        </div>
      </JDEachFrame>
    </Frame>
  );
};

export default inject(injectStore.matchMessageStore)(observer(MatchApplyJobDescription));
